import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { LockClosedIcon } from "@heroicons/react/solid";
import { useAuth } from "client/services/contexts/AuthServiceContext";
// import { Alert } from "react-bootstrap";
import Logo from "images/monogram.png";
import { fireBaseAnalytics } from "client/services/fireBase/firebaseConfig";
import loaders from "client/components/loaders";

export default function ForgotPassword() {
  useEffect(() => {
    fireBaseAnalytics.logEvent("forgotPasswordPage_visited");
  }, []);

  const emailRef = useRef();
  const { resetPassword } = useAuth();
  const [setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  async function handleSubmit(e) {
    fireBaseAnalytics.logEvent("resetPassword_button_clicked");

    e.preventDefault();

    try {
      setMessage("");
      setError("");
      setLoading(true);
      await resetPassword(emailRef.current.value);
      setMessage("Check your inbox for further instructions.");
    } catch {
      setError("Failed to reset password");
    }

    setLoading(false);
  }

  const onButtonClick = (eventName) => () => {
    fireBaseAnalytics.logEvent(eventName);
    setLoading(true);
  };

  if (loading) {
    return loaders.commonLoader();
  }

  return (
    <div style={{height: "100vh"}}>
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <img className="mx-auto h-20 w-auto" src={Logo} alt="Workflow" />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Reset Password
          </h2>
        </div>

        {message && (
          <div
            className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4"
            role="alert"
          >
            <p className="font-bold">Email Sent</p>
            <p>{message}</p>
          </div>
        )}

        <form className="mt-8 space-y-6" onSubmit={handleSubmit} method="POST">
          <input type="hidden" name="remember" defaultValue="true" />
          <div className="rounded-md shadow-sm -space-y-px">
            <div className="my-1">
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md rounded-b-md  focus:outline-none focus:ring-crimson focus:border-crimson focus:z-10 sm:text-sm"
                placeholder="Email address"
                ref={emailRef}
              />
            </div>
          </div>

          <div>
            <button
              disabled={loading}
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-crimson hover:bg-white hover:text-crimson focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-crimson hover:border hover:border-crimson"
            >
              <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                <LockClosedIcon
                  className="h-5 w-5 text-white group-hover:text-crimson"
                  aria-hidden="true"
                />
              </span>
              Reset Password
            </button>
          </div>

          <div className="flex items-center justify-between">
            <div className="text-sm"></div>

            <div className="text-sm">
              <Link
                className="font-medium text-crimson hover:underline"
                to="/login"
                onClick={onButtonClick(
                  "login_page_visited_from_forgotPassword_page"
                )}
              >
                Log In
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
    </div>
  );
}
